export default "data:image/webp;base64,UklGRjYAAABXRUJQVlA4TCoAAAAvJwAGAAWRhglpSEQS+m941KVYMJn/EWA0AoEUZ7LY/c82Pt9NYAm3gQ8="